module.exports = __webpack_public_path__ + "img/info-04.bbbe9c0e.jpg";